import { useConfigurator } from '@/app/store/configurator/hooks/use-configurator';
import { Section } from '@/entities/section';
import { FRONT_SECTION_TOOLS_HEIGHT } from '@/shared/constants/configurator';
import { DISPLAY_SCALE } from '@/shared/constants/editor';
import {
	calculateConfiguratorDepth,
	calculateConfiguratorHeight,
	calculateConfiguratorWidth,
} from '@/shared/lib/configurator';
import { EditorSide } from '@/shared/types/configurator';
import { Size } from '@/shared/ui/size/size';
import { useTranslation } from 'react-i18next';
import {
	FRONT_EDITOR_TOOLS_HEIGHT,
	FRONT_EDITOR_TOOLS_WIDTH,
} from '../../constants/editor.constants';
import { calculateSectionLeftPositions } from '../../lib/styles';
import { AddSectionButton } from '../add-section-button/add-section-button';
import styles from './front-editor.module.css';

export const FrontEditor = () => {
	const {
		state: { sections, wallMounted, doubleSided },
	} = useConfigurator();
	const { t } = useTranslation();

	const height = calculateConfiguratorHeight(sections);
	const width = calculateConfiguratorWidth(sections, wallMounted);
	const depth = calculateConfiguratorDepth(sections, doubleSided);

	const leftPositions = calculateSectionLeftPositions(sections, wallMounted);

	return (
		<div
			className={styles.wrapper}
			style={{
				width: width * DISPLAY_SCALE + FRONT_EDITOR_TOOLS_WIDTH,
				height:
					height * DISPLAY_SCALE + FRONT_SECTION_TOOLS_HEIGHT + FRONT_EDITOR_TOOLS_HEIGHT,
			}}
		>
			<Size
				style={{ height: height * DISPLAY_SCALE }}
				value={`${height} ${t('units.mm')}`}
				label={t('size.height.rackTitle')}
				className={styles.heightSize}
				type="height"
			/>
			<Size
				style={{ width: width * DISPLAY_SCALE }}
				value={`${width} ${t('units.mm')}`}
				className={styles.widthSize}
				label={t('size.width.rackTitle')}
				type="width"
			/>
			<Size
				options={{ rotate: -30, labelClassName: styles.depthLabel }}
				value={`${depth} ${t('units.mm')}`}
				className={styles.depthSize}
				label={t('size.depth.rackTitle')}
				type="rotate"
			/>
			<div className={styles.sectionsWrapper}>
				<div
					className={styles.sections}
					style={{
						height: height * DISPLAY_SCALE + FRONT_SECTION_TOOLS_HEIGHT,
						width: width * DISPLAY_SCALE,
						minWidth: width * DISPLAY_SCALE,
					}}
				>
					{sections.map((section, index) => (
						<Section
							key={index}
							section={section}
							side={EditorSide.FRONT}
							sectionIndex={index}
							className={styles.section}
							style={{
								left: leftPositions[index],
							}}
						/>
					))}
				</div>
				<AddSectionButton />
			</div>
		</div>
	);
};
